import { cn } from '@utils/cn';

import { Icon } from '@ui-component-library/components/Icon';
import { Text } from '@ui-component-library/components/Text';

import { wrapperClasses } from './Chip.styles';
import type { ChipProps } from './Chip.types';

export const Chip = ({ className, icon, label, size, onClick }: ChipProps) => {
  const font = size === 'small' ? 'text-xs/leading-normal/normal' : 'text-xs/leading-normal/medium';
  return (
    <div className={cn(wrapperClasses({ size }), className)} onClick={onClick}>
      {icon && <Icon name={icon} size={size} />}
      <Text variant={font}>{label}</Text>
    </div>
  );
};
